import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Exception } from '../libs';
import { ERR_CODE_MISSING_REQUIRED_ARGUMENTS } from '../constants';
/**
 * 检测依赖
 * @description
 * 因为流程需要各种TOKEN
 */

export var Required = function Required(props) {
  return function (_target, _property, descriptor) {
    var noConfilt = descriptor.value;

    if (typeof noConfilt === 'function') {
      descriptor.value = function () {
        var _this = this;

        if (Array.isArray(props)) {
          if (props.filter(function (name) {
            return typeof _this[name] === 'undefined';
          }).length > 0) {
            throw new Exception(_objectSpread({}, ERR_CODE_MISSING_REQUIRED_ARGUMENTS));
          }
        }

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return noConfilt.call.apply(noConfilt, [this].concat(args));
      };
    }

    return descriptor;
  };
};